// Read-only Entity view over legacy demon.c Enemy structs.

import type { Entity } from './entity';
import type { Enemy } from './types';

const LEGACY_BEHAVIOR = 'meritous:legacy-demon';
const LEGACY_RENDER = 'legacy/enemy';

export function legacyEnemyToEntity(e: Enemy): Entity {
  return {
    id: -1,
    kind: 'enemy',
    pos: { x: e.x, y: e.y },
    hp: e.lives,
    maxHp: e.lives,
    behaviorId: LEGACY_BEHAVIOR,
    renderId: `${LEGACY_RENDER}/${e.enemy_type}`,
    roomId: e.room,
    flags: e.delete_me ? 1 : 0,
    data: {
      legacy: true,
      enemy_type: e.enemy_type,
      str: e.str,
      speed: e.speed,
    },
  };
}

export function isLegacyBehavior(behaviorId: string): boolean {
  return behaviorId.startsWith('meritous:legacy-');
}
